<!-- 音视频动画 -->
<template>
  <div class="video-animation-container">
    <div class="video-animation-item" v-for="item in AnimationList">
      <div class="video-animation-label">{{ item.name }}</div>
      <div>
        <el-input
          v-model="item.value"
          size="mini"
          v-if="item.type == propsTypes.string"
        ></el-input>
        <el-switch
          v-model="item.value"
          active-color="#13ce66"
          inactive-color="#ff4949"
          v-if="item.type == propsTypes.switch"
        >
        </el-switch>
      </div>
    </div>
    <div class="animate-menus">
      <el-button
        type="primary"
        icon="el-icon-video-play"
        @click="changeState('play')"
        >播放</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-video-pause"
        @click="changeState('pause')"
        >暂停</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-circle-close"
        @click="changeState('stop')"
        >停止</el-button
      >
    </div>
  </div>
</template>
<script>
import AnimationList from "../../types/video-animation";
import { propsTypes } from "../../types/sprite-types";
export default {
  data() {
    return {
      AnimationList,
      propsTypes,
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },
  methods: {
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }

      if (!this.active) return;
      this.AnimationList.forEach((item) => {
        if (this.active[item.key]) {
          item.value = this.active[item.key];
        }
      });
    },
    saveConfig() {
      if (!this.active) return;
      this.AnimationList.forEach((item) => {
        this.active[item.key] = item.value;
        if (this.active[item.key] !== item.value) {
          this.topo.stageCanvas.setValue({
            id: this.active.id,
            [key]: item.value,
          });
        }
      });
    },
    changeState(state) {
      if (!this.active) return;
      switch (state) {
        case "play":
          // 播放
          this.saveConfig();
          this.topo.stageCanvas.startVideo(this.active.id);
          break;
        case "pause":
          this.topo.stageCanvas.pauseVideo(this.active.id);
          break;
        case "stop":
          this.topo.stageCanvas.stopVideo(this.active.id);
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.video-animation-container {
  .video-animation-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .video-animation-label {
      width: 120px;
    }
  }
  .animate-menus {
    display: flex;
    margin-top: 30px;
  }
}
</style>